import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";

export default function DivisionWiseProduct({ data }: any) {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        if (!data) return;

        const result = Object.entries(data).map(([key, value]) => ({
            name: key
                .replace(/_product_count$/, "")
                .replace(/_/g, " ")
                .replace(/\b\w/g, (c) => c.toUpperCase()),
            count: Number(value),
        }));

        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue("--text-color");
        const textColorSecondary = documentStyle.getPropertyValue("--text-color-secondary");
        const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

        const chartDataObj = {
            labels: result.map((item) => `${item.name}(${item.count})`),
            datasets: [
                {
                    label: "Division Wise Product",
                    backgroundColor: [
                        "#42A5F5",
                        "#66BB6A",
                        "#FFA726",
                        "#AB47BC",
                        "#EC407A",
                        "#26C6DA",
                        "#FF7043",
                    ],
                    borderColor: [
                        "#42A5F5",
                        "#66BB6A",
                        "#FFA726",
                        "#AB47BC",
                        "#EC407A",
                        "#26C6DA",
                        "#FF7043",
                    ],
                    data: result.map((item) => item.count),
                },
            ],
        };

        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                    },
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500,
                        },
                    },
                    grid: {
                        display: false,
                        drawBorder: false,
                    },
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false,
                    },
                },
            },
        };

        setChartData(chartDataObj);
        setChartOptions(options);
    }, [data]);

    return (
        <div className="card">
            <div style={{ height: "456px" }}>
                <Chart
                    type="bar"
                    data={chartData}
                    options={chartOptions}
                    style={{ height: "100%" }}
                />
            </div>
        </div>
    );
}